<template lang="pug">
  el-container
    el-header(height="auto")
      el-form(:model="form" inline label-suffix=":" ref="form")
        el-form-item(label="城市" prop="cityName")
          el-input(v-model="form.cityName")
        el-form-item
          el-button(
            type="primary"
            icon="el-icon-search"
            :loading="searching"
            @click="search"
          ) 搜索
    el-main
      grid(:remoteMethod="getTableData" ref="grid")
        el-table-column(prop="cityName" label="城市")
        el-table-column(prop="bikeDataLimit" label="单车数据权限时间")
        el-table-column(prop="bicycleDataLimit" label="助力车数据数据权限时间")
        el-table-column(prop="updateTime" label="更新时间")
        el-table-column(label="操作")
          template(slot-scope="{row}")
            el-button(type="text" @click="changeBikeNumber(row)" size="mini") 定投车辆
            el-button(type="text" @click="showPermission(row)" size="mini") 数据权限
      el-dialog(
        :title="`定投车辆 - ${cityName}`"
        width="30%"
        :visible.sync="dialogVisible"
      )
        bike-form(
          :id="cityGuid"
          @submit="bikeFormSubmit"
          v-if="dialogVisible"
        )
      el-dialog(
        title="数据权限"
        width="30%"
        :visible.sync="permissionDialogVisible"
      )
        el-form(label-suffix=":" :model="dataForm")
          el-form-item(label="普通车数据起始日期")
            el-date-picker(
              v-model="dataForm.bikeDataLimit"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="date"
            )
          el-form-item(label="助力车数据起始日期")
            el-date-picker(
              v-model="dataForm.bicycleDataLimit"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="date"
            )
          el-form-item
            el-button(@click="permissionSubmit" type="success") 保存
</template>

<script>
import { getCityListByPage, dataLimit, setBicycleDataLimit } from '@/api/user';
import grid from '@/components/grid';
import bikeForm from './bikeForm';

export default {
  name: 'UserList',
  components: {
    grid,
    bikeForm,
  },
  data() {
    return {
      form: {
        cityName: '',
      },
      dataForm: {
        bikeDataLimit: null,
        bicycleDataLimit: null
      },
      cityGuid: '',
      cityName: '',
      searching: false,
      dialogVisible: false,
      permissionDialogVisible: false
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    async getTableData(data) {
      const res = await getCityListByPage(data);
      return { data: res.data, total: res.total };
    },
    async search() {
      this.searching = true;
      await this.$refs.grid.loadData(this.form);
      this.searching = false;
    },
    showPermission(row) {
      this.cityGuid = row.cityGuid;
      this.dataForm.bikeDataLimit = row.bikeDataLimit;
      this.dataForm.bicycleDataLimit = row.bicycleDataLimit;
      this.permissionDialogVisible = true;
    },
    async permissionSubmit() {
      const data = {
        ...this.dataForm,
        cityGuid: this.cityGuid
      };
      await Promise.all([dataLimit(data), setBicycleDataLimit(data)]);

      this.$message.success('操作成功');
      this.permissionDialogVisible = false;
      this.search();
    },
    changeBikeNumber(row) {
      this.cityGuid = row.cityGuid;
      this.cityName = row.cityName;
      this.dialogVisible = true;
    },
    bikeFormSubmit() {
      this.dialogVisible = false;
      this.search();
    }
  },
};
</script>

<style lang="scss" scoped>
.green{
  font-size: 18px;
  color: #67c23a;
}
.red{
  font-size: 18px;
  color: #dd454d;
}
</style>



// WEBPACK FOOTER //
// src/views/system/city.vue?c9b2f91e